const StockAvailability = {

    // FIELDS
    "department": "Department",
    "location": "Location",
    "component": "Component",
    "equipment": "Equipment",
    "available_quantity": "Available Quantity",
    "search": "Search",

    // PAGE HEADER
    "stock_availability": "Stock Availability",

    // TABLE HEADER
    "table_department": 'DEPARTMENT',
    "table_location": 'LOCATION',
    "table_component": 'COMPONENT',
    "table_equipment": 'EQUIPMENT',
    "table_make": "MAKE",
    "table_new_part_number": "NEW PART NUMBER",
    "table_old_part_number": "OLD PART NUMBER",
    "table_km_item_code": "KM ITEM CODE",
    "table_available_quantity": "AVAILABLE QUANTITY",

}

export default StockAvailability;